export const OK = 200;
export const CREATED = 201;
export const NO_CONTENT = 204;
export const UNAUTHORIZED = 401;
export const NOT_FOUND = 404;
export const NOT_ACCEPTABLE = 406;
export const CONFLICT = 409;
export const UNAVAILABLE_FOR_LEGAL_REASONS = 451;
export const SERVER_ERROR = 500;
export const METHOD_NOT_ALLOWED = 405;
export const BAD_REQUEST = 400;
